module.exports = __webpack_public_path__ + "img/faster-problem-resolution.79944af3.svg";